// removed by extract-text-webpack-plugin
module.exports = {"Stats":"_2vcRv9HVxsZECQKRXzNWCA","Error":"_2rqZZltWSUlJFjI8X1EmLg","Spinner":"BjJvWoCq4z4hCEyKUXB50","spin":"_3mljUVdB09td8zFORHYvwb"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Stats/Stats.css
// module id = 124
// module chunks = 0